export default [
  {
    path: '/admin/vat-codes',
    name: 'vat-codes',
    meta: { requiresAuth: true },
    component: () => import('@/pages/setting/vat-code/index.vue')
  }
]
